The object identifier for the `PositionProfile`.

This is duplicated from the `profileId` field to satisfy the `PositionProfile` interface.
